import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fields" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "c-field" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "c-field__label",
    for: "isMarried"
  }, "配信設定"),
  /*#__PURE__*/_createElementVNode("div", { class: "c-field__body" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "p-mypage__txt" }, [
      /*#__PURE__*/_createTextVNode("集英社オンラインが厳選した記事をお届けします。"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("注目のニュース記事からアカデミックなコラムまで、まとめてご覧いただけます。"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ぜひ、ご登録ください。")
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "c-field" }
const _hoisted_5 = {
  class: "c-field__body",
  style: {"margin-left":"auto","margin-right":"auto","justify-content":"center"}
}
const _hoisted_6 = { class: "c-field__radio" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "mail_magazine_enable" }, "受け取る", -1)
const _hoisted_8 = { class: "c-field__radio" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "mail_magazine_disable" }, "受け取らない", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "c-field has-submit has-mt" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "入力内容を確認する", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "キャンセル", -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, { "validation-schema": _ctx.schema }, {
    default: _withCtx(({ errors, meta }) => [
      _createElementVNode("fieldset", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "mail_magazine_enable",
                name: "mainMailMagazine",
                value: true,
                modelValue: _ctx.userShueishaOnline.isSendMailMagazine,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userShueishaOnline.isSendMailMagazine) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "mail_magazine_disable",
                name: "mainMailMagazine",
                value: false,
                modelValue: _ctx.userShueishaOnline.isSendMailMagazine,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userShueishaOnline.isSendMailMagazine) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_9
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.mainMailMagazine), 513), [
          [_vShow, errors.mainMailMagazine]
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "ha-btn is-submit",
            type: "button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveConfirm && _ctx.moveConfirm(...args))),
            disabled: !meta.valid
          }, _hoisted_14, 8, _hoisted_12),
          _createElementVNode("button", {
            class: "ha-btn ha-btn--outline",
            type: "button",
            disabled: _ctx.isDeterringRef,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.backLinkageSite && _ctx.backLinkageSite(...args)))
          }, _hoisted_17, 8, _hoisted_15)
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}